/**
 * Helper functions for Product Page Funnel calculations
 * This is a 4-step funnel: Product Views -> Add to Cart -> Checkout -> Purchase
 */

/**
 * Calculate conversion rates from funnel metrics
 */
export function calculateConversionRates(
  productViewers: number,
  addersToCart: number,
  checkouts: number,
  purchasers: number,
) {
  const productToCartConversion =
    productViewers > 0 ? (addersToCart / productViewers) * 100 : 0
  const cartToCheckoutConversion =
    addersToCart > 0 ? (checkouts / addersToCart) * 100 : 0
  const checkoutToPurchaseConversion =
    checkouts > 0 ? (purchasers / checkouts) * 100 : 0
  const productToPurchaseConversion =
    productViewers > 0 ? (purchasers / productViewers) * 100 : 0

  return {
    productToCartConversion,
    cartToCheckoutConversion,
    checkoutToPurchaseConversion,
    productToPurchaseConversion,
    productToCartAbandon: 100 - productToCartConversion,
    cartToCheckoutAbandon: 100 - cartToCheckoutConversion,
    checkoutToPurchaseAbandon: 100 - checkoutToPurchaseConversion,
    productToPurchaseAbandon: 100 - productToPurchaseConversion,
  }
}
